import { render, staticRenderFns } from "./AssignV3.vue?vue&type=template&id=c6f7ba72&scoped=true&"
import script from "./AssignV3.vue?vue&type=script&lang=js&"
export * from "./AssignV3.vue?vue&type=script&lang=js&"
import style0 from "./AssignV3.vue?vue&type=style&index=0&id=c6f7ba72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f7ba72",
  null
  
)

export default component.exports